import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUniversityContext, useUserContext } from '@/context';
import { Routes } from '@/routes';
import { App } from 'antd';

const NOTIFY_DURATION = 10;

export function AuthTimeout() {
  const { logout } = useUserContext();
  const { university } = useUniversityContext();
  const timerRef = useRef<NodeJS.Timeout>();
  const timerNotifyRef = useRef<NodeJS.Timeout>();
  const location = useLocation();
  const navigate = useNavigate();
  const timeoutDuration = university.autoLogoutTime * 1000;
  const { notification } = App.useApp();

  function userLogout() {
    logout();
    navigate(Routes.Login);
  }

  function notifyLogout() {
    notification.warning({
      key: 'notify-logout',
      placement: 'bottomLeft',
      message: 'شما تا لحظاتی دیگر از سیستم خارج میشوید',
      duration: NOTIFY_DURATION - 1,
      showProgress: true
    });
  }

  const resetTimer = () => {
    console.log('notification', notification);
    notification.destroy('notify-logout');
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      clearTimeout(timerNotifyRef.current);
    }
    timerRef.current = setTimeout(userLogout, timeoutDuration);
    timerNotifyRef.current = setTimeout(notifyLogout, timeoutDuration - (NOTIFY_DURATION * 1000));
  };

  useEffect(() => {
    resetTimer();
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        clearTimeout(timerNotifyRef.current);
      }
    };
  }, [location.pathname]);

  return null;
};

export default AuthTimeout;
